import fileDownload from "js-file-download";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/Button";
import Checkbox from "../../../components/Checkbox/Checkbox";
import DataTable from "../../../components/DataTable";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";
import EmptyState from "../../../components/EmptyState/EmptyState";
import { Input, Select, Textarea } from "../../../components/Inputs";
import Loading from "../../../components/Loading";
import Modal from "../../../components/Modal";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import { API_EXPORT, API_POST } from "../../../helpers/api";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
import { setNotification } from "../../../helpers/notification";
import { numberParse } from "../../../helpers/parsing";
import {
  clearItemDetails,
  clearSelectedReconciliation,
  getReconciliationInfoRequest,
  getReconciliationListRequest,
  getSelectedReconciliationDetailsRequest,
  getSelectedReconciliationItemDetailsRequest,
  removeReconciliationItemDetails,
  setFilterPeriod,
  setSelectedReconciliationId,
} from "../../../redux/actions/reconciliation";
import { setSelectedDateWithOrganization } from "../../../redux/actions/bilateralAgreements";

import { organizationFindByTermSearchRequest } from "../../../redux/actions/organizations";

import ComboBoxFindTerm from "../../../components/ComboBoxFindTerm";

const Reconciliation = ({ t }) => {
  const dispatch = useDispatch();
  const { status, description } = useSelector(
    (state) => state.reconciliation.info
  );

  const filterPeriod = useSelector(
    (state) => state.reconciliation.filterPeriod
  );

  const findBytermOrganization = useSelector((state) => state.organizations);

  const [orgForTerm, setOrgForTerm] = useState(null);

  const { reconciliationList, total, subTotalsInPage, subTotalsInSystem } =
    useSelector((state) => state.reconciliation);

  const loading = useSelector((state) => state.reconciliation.loading);
  const {
    selectedId,
    loadingDetails,
    details,
    loadingItemDetails,
    itemDetails,
    totalAmount,
    totalPrice,
    subTotalsInPage: selectedSubTotalsInPage,
  } = useSelector((state) => state.reconciliation.selectedReconciliation);

  const currentTerm = moment().format("YYYYMM");


  const [filteredPeriod, setFilteredPeriod] = useState(currentTerm);

  const [typeList, setTypeList] = useState([]);
  const [isActive, setIsActive] = useState(0);

  const [showItemDetailModal, setShowItemDetailModal] = useState(false);
  const [selectedItemDetail, setSelectedItemDetail] = useState(null);
  const [editItemDetail, setEditItemDetail] = useState({
    unitPrice: "",
    amount: "",
    description: "",
  });

  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [modalConfirmationDetails, setModalConfirmationDetails] = useState({
    header: "",
    body: "",
    approve: null,
  });
  const [detailsConfig, setDetailsConfig] = useState([]);

  const [reconciliationExportLoading, setReconciliationExportLoading] =
    useState(false);
  const [
    reconciliationDetailsExportLoading,
    setReconciliationDetailsExportLoading,
  ] = useState(false);
  const [
    reconciliationItemDetailsExportLoading,
    setReconciliationItemDetailsExportLoading,
  ] = useState(false);
  const [downloadFilter, setDownloadFilter] = useState({ term: filterPeriod });
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [activePage, setActivePage] = useState(0);

  const selectedDateWithOrganization = useSelector(
    (state) => state.bilateralAgreements.filters.selectedDateWithOrganization
  );

  const serverTimeInitial = useSelector(
    (state) => state.utilities.serverTimeInitial
  );

  const serverDate = moment(serverTimeInitial).format("DD.MM.YYYY-HH:mm:ss");
  const splitDate = serverDate.split("-");

  const splitDateArray = splitDate[0].split(".");
  const currentDate = [splitDateArray[2], splitDateArray[1]].join("-");

  const detailConstants = [
    {
      totalCredit: 0,
      totalDebit: 0,
      type: "ALIS",
      title: "YEK-G " + t("pages.default.reconciliation.table.buy"),
    },
    {
      totalCredit: 0,
      totalDebit: 0,
      type: "SATIS",
      title: "YEK-G " + t("pages.default.reconciliation.table.sell"),
    },
    {
      totalCredit: 0,
      totalDebit: 0,
      type: "PIU",
      title: "PIU",
    },
    {
      totalCredit: 0,
      totalDebit: 0,
      type: "GZ",
      title: t("pages.default.reconciliation.table.fee"),
    },
    {
      totalCredit: 0,
      totalDebit: 0,
      type: "DK",
      title: "DK",
    },
  ];

  const typeTitles = {
    ALIS: "YEK-G " + t("pages.default.reconciliation.table.buy"),
    SATIS: "YEK-G " + t("pages.default.reconciliation.table.sell"),
    PIU: "PIU " + t("pages.default.reconciliation.table.totalSum"),
    PIU_KATILIM: t(
      "pages.default.reconciliation.reconciliationPIUParticipation"
    ),
    GZ: t("pages.default.reconciliation.table.fee"),
    DK: t("pages.default.reconciliation.correctionItem"),
  };

  const statuses = {
    FINANCE: "FINANCE",
    NONE: "NONE",
    ERROR: "ERROR",
    RECONCILIATION: "RECONCILIATION",
    INVOICE: "INVOICE",
    DK: "DK",
  };

  const reconciliationColumns = [
    {
      name: t("pages.default.certificates.table.organizationId"),
      selector: "organizationId",
      sortable: true,
      showTitle: true,
      width: "200px",
    },
    {
      name: t("pages.default.certificates.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      showTitle: true,
      width: "500px",
    },
    {
      name: t("pages.default.certificates.table.licenseType"),
      selector: "licenseType",
      sortable: true,
      showTitle: true,
      width: "200px",
      cell: (row) => {
        return row.licenseType === "RETAIL"
          ? t("pages.default.YEKGParticipation.table.supplyCompany")
          : row.licenseType === "PRODUCTION"
          ? t("pages.default.YEKGParticipation.table.production")
          : row.licenseType === "CHARGING_NETWORK_OPERATOR"
          ? t("pages.default.YEKGParticipation.table.chargingNetworkOperator")
          : row.licenseType === "K1"
          ? t("pages.default.YEKGParticipation.table.k1GTS")
          : row.licenseType === "K2"
          ? t("pages.default.YEKGParticipation.table.k2GTS")
          : "";
      },
    },
    {
      name: t("pages.default.reconciliation.table.totalCredit"),
      selector: "totalCredit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.totalCredit, digit: 2 });
      },
      width: "230px",
      style: { textAlign: "left", paddingRight: "25px" },
      headerStyle: { textAlign: "left", paddingRight: "21px" },
    },
    {
      name: t("pages.default.reconciliation.table.totalDebit"),
      selector: "totalDebit",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.totalDebit, digit: 2 });
      },
      width: "230px",
      style: { textAlign: "left", paddingRight: "25px" },
      headerStyle: { textAlign: "left", paddingRight: "21px" },
    },
    {},
  ];

  const reconciliationDetailsColumns = [
    {
      name: t("pages.default.reconciliation.table.choose"),
      selector: "choose",
      sortable: false,
      width: "81px",
      cell: (row, index) => (
        <div style={{ display: "flex", justifyContent: "start" }}>
          <Checkbox
            checked={handleCheckboxIsChecked(row)}
            onChange={() => handleCheckBoxChange(row)}
            disabled={
              (!row.totalCredit && !row.totalDebit) || loadingItemDetails
            }
            id={`rc-detail-checkbox-${index}`}
          />
        </div>
      ),
    },
    {
      name: t("pages.default.reconciliation.table.itemName"),
      selector: "type",
      sortable: true,
      cell: (row) => typeTitles[row.type],
      width: "419px",
    },
    {
      name: t("pages.default.reconciliation.table.credit"),
      selector: "totalCredit",
      sortable: true,
      cell: (row) => (
        <div className="km__u--text-green-300">
          {numberParse(row.totalCredit, 2)}
        </div>
      ),
      width: "160px",
      style: { textAlign: "left", paddingRight: "25px" },
      headerStyle: { textAlign: "left", paddingRight: "21px" },
    },
    {
      name: t("pages.default.reconciliation.table.debit"),
      selector: "totalDebit",
      sortable: true,
      cell: (row) => (
        <div className="km__u--text-red-300">
          {numberParse(row.totalDebit, 2)}
        </div>
      ),
      width: "140px",
      style: { textAlign: "left", paddingRight: "25px" },
      headerStyle: { textAlign: "left", paddingRight: "21px" },
    },
    {},
  ];

  const reconciliationItemDetailsColumns = [
    {
      name: t("pages.default.reconciliation.table.processType"),
      selector: "type",
      sortable: true,
      cell: (row) => typeTitles[row.type],
    },
    {
      name: t("pages.default.reconciliation.table.processDay"),
      selector: "createdDate",
      sortable: true,
      cell: (row) => moment(row.createdDate).format("DD.MM.YYYY"),
    },
    {
      name: t("pages.default.reconciliation.table.amount"),
      selector: "amount",
      sortable: true,
    },
    {
      name: t("pages.default.reconciliation.table.price"),
      selector: "unitPrice",
      sortable: true,
      cell: (row) => numberParse(row.unitPrice, 2),
    },
    {
      name: t("pages.default.reconciliation.table.total"),
      selector: "totalPrice",
      sortable: true,
      cell: (row) => numberParse(row.totalPrice, 2),
    },
    {
      name: t("pages.default.reconciliation.table.process"),
      selector: "process",
      sortable: false,
      width: "83px",
      cell: (row, index) =>
        status === statuses.INVOICE && row.type !== statuses.DK ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              title={t("ui.default.edit")}
              suffixIcon="edit"
              type="secondary"
              onClick={() => handleShowItemDetailEditModal(row)}
              disabled={status !== statuses.INVOICE}
              id={`rc-item-detail-edit-${index}`}
            />
          </div>
        ) : null,
    },
  ];

  useEffect(() => {
    dispatch(getReconciliationInfoRequest(filterPeriod));
    // setFilteredPeriod(filterPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let values = { value: null, date: filterPeriod };
    dispatch(organizationFindByTermSearchRequest(values));
  }, [filterPeriod]);

  useEffect(() => {
    findBytermOrganization?.list.map((item) => {
      const { organizationId, organizationName } = item;
      const orgData = {
        value: organizationId,
        name: organizationName,
      };
    });
  }, [filterPeriod, findBytermOrganization]);

  useEffect(() => {
    dispatch(
      getReconciliationListRequest({
        term: filterPeriod,
        operation: "RECONCILIATION",
      })
    );

    return () => {
      dispatch(clearSelectedReconciliation());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // set Period options
    let d = new Date();
    let filterPeriods = [];
    for (let i = 1; i <= 12; i++) {
      const name =
        t(`ui.default.months.${moment().subtract(i, "month").format("M")}`) +
        " " +
        moment().subtract(i, "month").format("YYYY");
      filterPeriods.push({
        name,
        value: moment().subtract(i, "month").format("YYYYMM"),
      });
      d.setMonth(d.getMonth() - 1);
    }
  }, [t, dispatch]);

  useEffect(() => {
    handleCreateReconciliationDetailsTable();
    if (Array.isArray(details) && details?.length > 0) {
      const typeList = details?.map((detail) => ({
        type: detail.type,
        isActive: false,
      }));
      setTypeList(typeList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  const handlePeriodChange = (e) => {
    const listDate = e.target.value.split("-");
    const value = listDate.join("");

    setIsActive(0);
    // const { value } = e.target;
    setFilteredPeriod(value);
    dispatch(setFilterPeriod(value));
  };

  useEffect(() => {
    dispatch(getReconciliationInfoRequest(filterPeriod));
  }, [filterPeriod]);

  const filterReconciliationList = () => {
    dispatch(getReconciliationInfoRequest(filterPeriod));
    dispatch(
      getReconciliationListRequest({
        term: filterPeriod,
        operation: "RECONCILIATION",
        organizationId: selectedDateWithOrganization?.organizationId ?? null,
      })
    );
    setDownloadFilter({ term: filterPeriod });
    setFilteredPeriod(filterPeriod);
    (selectedId || details?.length !== 0 || itemDetails.length !== 0) &&
      dispatch(clearSelectedReconciliation());
  };

  const handleSelectReconciliation = (row) => {
    setIsActive(0);

    dispatch(setSelectedReconciliationId(row.organizationId));
    dispatch(
      getSelectedReconciliationDetailsRequest({
        organizationId: row.organizationId,
        term: filteredPeriod,
        operation: "RECONCILIATION",
      })
    );
    setTypeList([]);
  };

  const handleSelectRow = (row) => {
    return selectedId && selectedId === row.organizationId;
  };

  const handleCreateReconciliationDetailsTable = () => {
    let updatedDetails = [];

    for (let data of detailConstants) {
      if (!(data.type === typeTitles.DK && status !== statuses.INVOICE)) {
        const foundDetail = details?.find(
          (detail) => data.type === detail.type
        );
        if (foundDetail) {
          updatedDetails.push({
            ...foundDetail,
          });
        } else {
          updatedDetails.push({
            ...data,
            totalCredit: 0,
            totalDebit: 0,
          });
        }
      }
    }
    setDetailsConfig(updatedDetails);
  };

  const handleCheckBoxChange = (row) => {
    const updatedTypeList = [...typeList];

    const foundType = updatedTypeList.find((item) => item.type === row.type);

    if (foundType.isActive) {
      setIsActive(isActive - 1);

      dispatch(removeReconciliationItemDetails(foundType.type));
    } else {
      setIsActive(isActive + 1);

      dispatch(
        getSelectedReconciliationItemDetailsRequest(selectedId, {
          term: filterPeriod,
          type: foundType.type,
          operation: "RECONCILIATION",
        })
      );
    }
    foundType.isActive = !foundType.isActive;
    setTypeList(updatedTypeList);
  };

  const handleCheckboxIsChecked = (row) => {
    if (Array.isArray(typeList) && typeList.length > 0) {
      const foundType = typeList.find((item) => item.type === row.type);

      return foundType ? foundType.isActive : false;
    }
    return false;
  };

  const handleShowItemDetailEditModal = (row) => {
    setSelectedItemDetail(row);
    setShowItemDetailModal(true);
  };

  const handleEditInputsChange = (e) => {
    const { name, value } = e.target;
    if (name === "unitPrice" && /^[+-]?\d*\.?\d*$/.test(value)) {
      setEditItemDetail((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }

    if (name !== "unitPrice") {
      setEditItemDetail((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSaveClick = async () => {
    setLoadingRequest(true);
    const reqParams = {
      parentId: selectedItemDetail.id,
      type: "DK",
      taxType: "KDV20",
      organizationId: selectedId,
      reconciliationTerm: filteredPeriod,
      unitPrice: editItemDetail.unitPrice,
      amount: editItemDetail.amount,
      description: editItemDetail.description,
    };
    try {
      await API_POST("reconciliation", {
        ...reqParams,
      });
      setLoadingRequest(false);
      setShowItemDetailModal(false);
      setEditItemDetail({
        unitPrice: "",
        amount: "",
        description: "",
      });
      dispatch(
        getSelectedReconciliationDetailsRequest({
          organizationId: orgForTerm,
          term: filteredPeriod,
          operation: "RECONCILIATION",
        })
      );
      setTypeList([]);
      dispatch(clearItemDetails());
      setNotification("success", t("pages.default.reconciliation.saveSuccess"));
    } catch (err) {
      setLoadingRequest(false);
      setNotification("error", err.response.data.message);
    }
  };

  const handleDisableSave = () => {
    const { unitPrice, amount, description } = editItemDetail;
    return !+unitPrice || amount === "" || description.trim().length < 10;
  };

  const handleSetModalConfirmationDetails = (type) => {
    setShowModalConfirmation(true);
    switch (type) {
      case "REPORT_TO_FINANCE":
        setModalConfirmationDetails({
          header: t("pages.default.reconciliation.reportToFinance.header"),
          body: t("pages.default.reconciliation.reportToFinance.body"),
          approve: handleReportToFinansClick,
        });
        break;
      case "COMPLETE_RECONCILIATION":
        setModalConfirmationDetails({
          header: t(
            "pages.default.reconciliation.completeReconciliation.header"
          ),
          body: t("pages.default.reconciliation.completeReconciliation.body"),
          approve: handleCompleteReconciliationClick,
        });
        break;
      default:
        break;
    }
  };

  const handleReportToFinansClick = async () => {
    setLoadingRequest(true);
    try {
      await API_POST("reconciliation/sendToFinance");
      setLoadingRequest(false);
      setShowModalConfirmation(false);
      setNotification(
        "success",
        t("pages.default.reconciliation.reportToFinance.success")
      );
      dispatch(getReconciliationInfoRequest(filteredPeriod));
    } catch (err) {
      setLoadingRequest(false);
      setNotification("error", err.response.data.message);
    }
  };

  const handleCompleteReconciliationClick = async () => {
    setLoadingRequest(true);
    try {
      await API_POST("reconciliation/finishReconciliation");
      setLoadingRequest(false);
      setShowModalConfirmation(false);
      setNotification(
        "success",
        t("pages.default.reconciliation.completeReconciliation.success")
      );
      dispatch(getReconciliationInfoRequest(filteredPeriod));
    } catch (err) {
      setLoadingRequest(false);
      setNotification("error", err.response.data.message);
    }
  };

  const downloadReconciliation = async () => {
    setReconciliationExportLoading(true);
    try {
      const res = await API_EXPORT("reconciliation/export/excel", {
        ...downloadFilter,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setReconciliationExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setReconciliationExportLoading(false);
    }
  };

  const downloadReconciliationDetails = async () => {
    setReconciliationDetailsExportLoading(true);
    try {
      const res = await API_EXPORT("reconciliation/export/excel", {
        ...downloadFilter,
        organizationId: selectedId,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setReconciliationDetailsExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setReconciliationDetailsExportLoading(false);
    }
  };

  const downloadReconciliationItemDetails = async () => {
    setReconciliationItemDetailsExportLoading(true);
    const filteredTypeList = typeList.filter((type) => type.isActive);
    const updatedTypeList =
      filteredTypeList.length > 0
        ? filteredTypeList.map((item) => item.type)
        : typeList.map((item) => item.type);
    try {
      const res = await API_EXPORT("reconciliation/export/excel", {
        ...downloadFilter,
        organizationId: selectedId,
        type: updatedTypeList,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setReconciliationItemDetailsExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setReconciliationItemDetailsExportLoading(false);
    }
  };

  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      getReconciliationListRequest({
        term: filterPeriod,
        operation: "RECONCILIATION",
        organizationId: orgForTerm ?? null,
        page: activePage,
        selector,
        direction,
      })
    );
  };
  return (
    <>
      {status === statuses.INVOICE && (
        <div className="km__p--reconciliation-msg km__p--reconciliation-success">
          {t("pages.default.reconciliation.reconciliationFinishedMsg")}
        </div>
      )}
      {status === statuses.ERROR && (
        <div className="km__p--reconciliation-msg km__p--reconciliation-error">
          {t("pages.default.reconciliation.errorMsg")} {description}
        </div>
      )}
      <div className="km__p--reconciliation-header">
        <h5 className="km__u--text-has-emphasis">
          {t("pages.default.reconciliation.title")}
        </h5>
        {filteredPeriod !== currentTerm && status !== statuses.INVOICE && (
          <div className="km__u--text_title">
            {t("pages.default.reconciliation.preReconciliation")}
          </div>
        )}
      </div>

      <div className="km__p--card">
        <div className="km__p--reconciliation-filter-container">
          <div className="km__u--text_title">
            {t("pages.default.reconciliation.title")}
          </div>
          <div className="km__p--reconciliation-filters">
            {/* <Select
              options={filterPeriodOptions}
              name="productionPeriod"
              value={filterPeriod}
              onChange={handlePeriodChange}
              id="rc-productionPeriod"
            /> */}
            <Input
              type="month"
              placement="bottom-end"
              name="historyRedemptionsStartDate"
              placeholder={t("pages.default.redemption.filter.startDate")}
              value={filterPeriod}
              max={currentDate}
              onChange={handlePeriodChange}
            />
            {/* <ComboBox t={t} /> */}
            {/* <Select
              options={orgForTermList}
              name="plant"
              onChange={(e) => setOrgForTerm(e.target.value)}
            /> */}

            <ComboBoxFindTerm
              inputPlaceholder={t("ui.default.searchOrganization")}
              selectedOrganization={selectedDateWithOrganization}
              organizationSelect={setSelectedDateWithOrganization}
              id="ba-history-sellerOrganization"
              date={filteredPeriod}
            />
            <Button
              label={t("ui.default.filter")}
              onClick={filterReconciliationList}
              id="rc-filter"
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              suffixIcon="download"
              onClick={downloadReconciliation}
              disabled={reconciliationExportLoading}
              id="rc-download"
            />
          </div>
        </div>

        {!loading && (
          <>
            {/* <DataTable
              columns={reconciliationColumns}
              data={reconciliationList}
              rowKey="organizationId"
              pagination
              paginationPerPage={10}
              selectableRow
              rowSelection={(row) => handleSelectReconciliation(row)}
              isRowSelected={(row) => handleSelectRow(row)}
            /> */}
            <DataTableServerSideRendering
              columns={reconciliationColumns}
              data={reconciliationList}
              rowKey="id"
              sortedColumn={sortedColumn}
              setSortedColumn={setSortedColumn}
              sortDirection={sortDirection}
              setSortDirection={setSortDirection}
              pagination
              activePage={activePage}
              totalPageCount={total?.totalPage}
              handleFetchData={handleClick}
              selectableRow
              rowSelection={(row) => handleSelectReconciliation(row)}
              isRowSelected={(row) => handleSelectRow(row)}
              subTotals={[
                {
                  totalCount: subTotalsInSystem?.totalCredit,
                  // countInPage: subTotalsInPage.totalCredit,
                  sumIndex: 3,
                },
                {
                  totalCount: subTotalsInSystem?.totalDebit,
                  // countInPage: subTotalsInPage.totalDebit,
                  sumIndex: 4,
                },
              ]}
            />
            {filteredPeriod !== currentTerm && status !== statuses.INVOICE && (
              <div className="km__p--reconciliation-button-group">
                <Button
                  type="destructive"
                  label={t(
                    "pages.default.reconciliation.reportToFinance.title"
                  )}
                  onClick={() =>
                    handleSetModalConfirmationDetails("REPORT_TO_FINANCE")
                  }
                  disabled={
                    (status !== statuses.NONE) === (status !== statuses.ERROR)
                  }
                  id="rc-reportToFinance"
                />
                <Button
                  type="primary"
                  label={t(
                    "pages.default.reconciliation.completeReconciliation.title"
                  )}
                  onClick={() =>
                    handleSetModalConfirmationDetails("COMPLETE_RECONCILIATION")
                  }
                  disabled={status !== statuses.RECONCILIATION}
                  id="rc-completeReconciliation"
                />
              </div>
            )}
          </>
        )}
        {loading && (
          <Loading
            text={t("pages.default.reconciliation.reconciliationLoading")}
          />
        )}
      </div>

      {selectedId ? (
        <>
          <div className="km__p--card">
            <div className="km__p--reconciliation-filter-container">
              <div className="km__u--text_title">
                {t("pages.default.reconciliation.detailsTitle")}
              </div>
              <div className="km__p--reconciliation-filters">
                <Button
                  type="secondary"
                  label={t("ui.default.download")}
                  suffixIcon="download"
                  onClick={downloadReconciliationDetails}
                  disabled={reconciliationDetailsExportLoading}
                  id="rc-detail-download"
                />
              </div>
            </div>
            {!loadingDetails && (
              <DataTable
                columns={reconciliationDetailsColumns}
                data={detailsConfig}
                rowKey="type"
                subTotals={[
                  {
                    totalCount: convertNumberToFrontend({
                      num: selectedSubTotalsInPage.totalCredit,
                      digit: 2,
                    }),
                    countInPage: "",
                    sumIndex: 2,
                  },
                  {
                    totalCount: convertNumberToFrontend({
                      num: selectedSubTotalsInPage.totalDebit,
                      digit: 2,
                    }),
                    countInPage: "",
                    sumIndex: 3,
                  },
                ]}
              />
            )}
            {loadingDetails && (
              <Loading
                text={t(
                  "pages.default.reconciliation.reconciliationDetailsLoading"
                )}
              />
            )}
          </div>

          <div className="km__p--card">
            <div className="km__p--reconciliation-filter-container">
              <div className="km__u--text_title">
                {t("pages.default.reconciliation.itemDetailsTitle")}
              </div>
              <div className="km__p--reconciliation-filters">
                <Button
                  type="secondary"
                  label={t("ui.default.download")}
                  suffixIcon="download"
                  onClick={downloadReconciliationItemDetails}
                  disabled={reconciliationItemDetailsExportLoading}
                  id="rc-item-detail-download"
                />
              </div>
            </div>

            {!loadingItemDetails && (
              <DataTable
                columns={reconciliationItemDetailsColumns}
                data={itemDetails}
                rowKey="id"
                pagination
                paginationPerPage={5}
                defaultSortedField="createdDate"
                subTotals={
                  isActive >= 2 || isActive === 0
                    ? ""
                    : [
                        {
                          totalCount: totalAmount,
                          sumIndex: 2,
                        },

                        {
                          totalCount: convertAmountToFrontend(totalPrice),
                          countInPage: "",
                          sumIndex: 4,
                        },
                      ]
                }
              />
            )}
            {itemDetails.length === 0 && !loadingItemDetails && (
              <EmptyState
                icon="file-text"
                text={t(
                  "pages.default.reconciliation.reconciliationItemDetailsNotFound"
                )}
              />
            )}
            {loadingItemDetails && (
              <Loading
                text={t(
                  "pages.default.reconciliation.reconciliationItemDetailsLoading"
                )}
              />
            )}
          </div>

          {itemDetails.length !== 0 && (
            <Modal
              isOpen={showItemDetailModal}
              toggle={() => setShowItemDetailModal(false)}
            >
              <div className="km__p--reconciliation-item-edit-modal">
                <div className="km__p--reconciliation-item-edit-modal-header">
                  {t("pages.default.reconciliation.itemEditModalTitle")}
                </div>
                <div className="km__p--reconciliation-item-edit-modal-body">
                  <Input
                    label={t("pages.default.reconciliation.inputs.unitPrice")}
                    name="unitPrice"
                    type="number"
                    value={editItemDetail.unitPrice}
                    onChange={handleEditInputsChange}
                    id="rc-modal-unitPrice"
                  />
                  <Input
                    label={t("pages.default.reconciliation.inputs.amount")}
                    name="amount"
                    type="number"
                    min={1}
                    value={editItemDetail.amount}
                    onChange={handleEditInputsChange}
                    id="rc-modal-amount"
                  />
                  <Textarea
                    label={t("pages.default.reconciliation.inputs.description")}
                    name="description"
                    value={editItemDetail.description}
                    onChange={handleEditInputsChange}
                    id="rc-modal-description"
                  />
                </div>
                <div className="km__p--reconciliation-item-edit-modal-footer">
                  <Button
                    label={t("ui.default.close")}
                    type="secondary"
                    onClick={() => setShowItemDetailModal(false)}
                    disabled={loadingRequest}
                    id="rc-modal-close"
                  />
                  <Button
                    label={t("ui.default.save")}
                    type="primary"
                    onClick={() => handleSaveClick()}
                    disabled={handleDisableSave() || loadingRequest}
                    id="rc-modal-save"
                  />
                </div>
              </div>
            </Modal>
          )}
        </>
      ) : null}

      <ModalConfirmation
        isOpen={showModalConfirmation}
        toggle={() => setShowModalConfirmation(false)}
        {...modalConfirmationDetails}
        loading={loadingRequest}
      />
    </>
  );
};

export default Reconciliation;
